import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollAnimated"]

  onScroll() {
    this.scrollAnimatedTargets.forEach(element => {
      const elementTop = element.getBoundingClientRect().top
      if (elementTop + 200 < window.innerHeight) {
        element.classList.add("scrolled-to")
      }
    })
  }
}
